// Org updates feed.
import { useEffect, useState } from 'react';
import { Spinner } from '@/components/ui';
import { organizationService } from '@/services/api';
import { useOrgPageMeta, useOrgSlug } from '@/layouts/orgSettingsMeta';
import OrgUpdatesFeed from '@/features/organization/OrgUpdatesFeed';
import OrgSectionHeading from '@/features/organization/OrgSectionHeading';
import type { OrgUpdate } from '@/types';

export default function UpdatesPage() {
  const slug = useOrgSlug();
  useOrgPageMeta('Updates', 'Activity and notifications for this organization.');

  const [rows, setRows] = useState<OrgUpdate[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    organizationService
      .getUpdates(slug)
      .then((data) => {
        if (active) setRows(data.rows);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [slug]);

  return (
    <div className="org-panel">
      <OrgSectionHeading plain title="Recent updates" />
      {loading ? (
        <div className="org-tab-loading">
          <Spinner />
        </div>
      ) : (
        <OrgUpdatesFeed rows={rows} />
      )}
    </div>
  );
}
